// src/pages/Warranty.jsx
import React from "react";
import { Link } from "react-router-dom";

const Bullet = ({ children }) => (
  <li className="flex gap-3">
    <span className="mt-1 inline-block h-2 w-2 rounded-full bg-orange-500" />
    <span className="text-gray-800">{children}</span>
  </li>
);

export default function Warranty() {
  return (
    <main className="max-w-3xl mx-auto p-6">
      <div className="bg-white rounded-2xl shadow-md p-6">
        <h1 className="text-3xl font-bold text-orange-500 mb-3">
          Гарантийное обслуживание
        </h1>
        <p className="text-gray-600 mb-6">
          Мы заботимся о вашем опыте после покупки. Ниже — как действует
          гарантия и как к нам обратиться.
        </p>

        {/* Сроки гарантии */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Сроки гарантии</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="rounded-lg border border-gray-200 p-4">
              <div className="text-sm text-gray-500">Смартфоны</div>
              <div className="text-lg font-bold">12 месяцев</div>
            </div>
            <div className="rounded-lg border border-gray-200 p-4">
              <div className="text-sm text-gray-500">Другая техника</div>
              <div className="text-lg font-bold">6 месяцев</div>
            </div>
          </div>
        </section>

        {/* Как обратиться */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Как обратиться по гарантии</h2>
          <ol className="list-decimal pl-5 space-y-2 text-gray-800">
            <li>
              Принесите устройство в любой наш магазин вместе с{" "}
              <span className="font-medium">кассовым чеком</span> и{" "}
              <span className="font-medium">гарантийным талоном</span> (выдается при покупке техники).
            </li>
            <li>
              Мы проведём первичную диагностику и зарегистрируем обращение.
            </li>
            <li>
              Далее мы, как магазин, связываемся с{" "}
              <a
                href="https://mixtech-shop.ru/brands/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-600 hover:underline font-medium"
              >
                авторизованным сервисным центром MixTech
              </a>
              , который выполняет гарантийный ремонт техники <span className="font-medium">Xiaomi</span>.
            </li>
          </ol>
          <div className="mt-3 rounded-lg bg-orange-50 border border-orange-200 p-3 text-sm text-orange-900">
            Если устройство <span className="font-semibold">не РСТ</span>
            &nbsp;(неофициальная поставка), гарантийное обслуживание берём на себя мы — магазин.
          </div>
        </section>

        {/* Что является гарантийным случаем */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Гарантийные случаи</h2>
          <ul className="space-y-2">
            <Bullet>Заводские (производственные) дефекты, проявившиеся в процессе нормальной эксплуатации.</Bullet>
            <Bullet>Неисправности, не связанные с нарушением условий эксплуатации, хранения и транспортировки.</Bullet>
            <Bullet>Поломки, возникшие в течение гарантийного срока и подтверждённые диагностикой.</Bullet>
          </ul>
        </section>

        {/* Что не покрывается */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Не относится к гарантии</h2>
          <ul className="space-y-2">
            <Bullet>Механические повреждения, следы ударов, трещины, вмятины, следы попадания влаги.</Bullet>
            <Bullet>Следы несанкционированного ремонта/вмешательства, установка неоригинального ПО, рутирование.</Bullet>
            <Bullet>Повреждения вследствие неправильного питания, аксессуаров, кабелей, перепадов напряжения.</Bullet>
            <Bullet>Расходные материалы и естественный износ (аккумуляторы, кабели, чехлы и пр.).</Bullet>
          </ul>
        </section>

        {/* Что принести */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Что взять с собой</h2>
          <ul className="space-y-2">
            <Bullet>Устройство в полной комплектации (по возможности).</Bullet>
            <Bullet>Кассовый чек / электронный чек.</Bullet>
            <Bullet>Гарантийный талон, выданный при покупке.</Bullet>
            <Bullet>Краткое описание неисправности (когда проявляется, как воспроизвести).</Bullet>
          </ul>
        </section>

        <div className="text-sm text-gray-500">
          Обращаясь в магазине, вы соглашаетесь с процедурой диагностики и передачи в авторизованный сервис.
        </div>

        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-orange-500 hover:bg-orange-600 text-white px-4 py-2"
          >
            ← На главную
          </Link>
        </div>
      </div>
    </main>
  );
}
